import { createSelector } from 'reselect'

const frontFlowState = state => state.entities.frontFlow

export const getFlowType = createSelector([frontFlowState], frontFlow =>
  frontFlow.get('flowType', null)
)
